import { HttpEvent, HttpEventType } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store, select } from "@ngrx/store";
import { catchError, concatMap, exhaustMap, map, mergeMap, switchMap, withLatestFrom } from "rxjs/operators";


import { FilesActions } from "../actions/files.actions";
import { SearchActions } from "../actions/search.actions";
import { Observable } from "rxjs";
import { selectAllCarDocumentsFolders, selectAllCarImageSamples, selectAllCarImagesFolders, selectSearchFetchingResults } from "../state/app.state";
import { Car } from "src/app/public/car/models/car.model";
import { FileData } from "src/app/public/common/models/file-data.model";
import { FileService } from "src/app/public/common/services/file.service";



@Injectable()
export class FilesApiEffects{

    carImagesFolders$: Observable<Map<string, Array<FileData>>>;

    imageFolders: Map<string, Array<FileData>> = new Map();

    carDocumentsFolders$: Observable<Map<string, Array<FileData>>>;

    documentFolders: Map<string, Array<FileData>> = new Map();

    carImageSamples$: Observable<Map<string, Blob>>;

    imageSamples: Map<string, Blob> = new Map();


    constructor(
        private fileService: FileService,
        private actions$: Actions,
        private store: Store
    ){
        this.carImagesFolders$ = store.select(selectAllCarImagesFolders);
        this.carDocumentsFolders$ = store.select(selectAllCarDocumentsFolders);

        this.carImageSamples$ = store.select(selectAllCarImageSamples);

        this.carImagesFolders$.subscribe( (images) => {
           // console.log("helloooooooooooooooooooo");

            this.imageFolders = new Map(images);
            //this.imageFolders = JSON.parse(JSON.stringify(images));
            //this.imageFolders = AppFunctions.deepCopy<Map<string, Array<ImageDatas>>>(images);
        });

        this.carDocumentsFolders$.subscribe( (documents) => {
            // console.log("helloooooooooooooooooooo");
 
             this.documentFolders = new Map(documents);
             //this.imageFolders = JSON.parse(JSON.stringify(images));
             //this.imageFolders = AppFunctions.deepCopy<Map<string, Array<ImageDatas>>>(images);
         });

        this.carImageSamples$.subscribe( (imageSamples) => {
            //console.log("helloooooooooooooooooooo");

            this.imageSamples = new Map(imageSamples);
            //this.imageFolders = JSON.parse(JSON.stringify(images));
            //this.imageFolders = AppFunctions.deepCopy<Map<string, Array<ImageDatas>>>(images);
        });
    }
/*
    uploadCarImages$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(FilesActions.uploadCarImageSubmit),
            mergeMap ( (action) => {
                //console.log(" 1 helhyloooo"+action.carId);
                return this.fileService
                    .uploadCarImageFile(action.file)
                    .pipe( 
                        mergeMap( (filename: string) => { 
                            //console.log("helhyloooo "+action.carId);
                            return [
                                FilesActions.uploadCarImageSuccess ( { carId: action.carId, filename: filename } ),
                                FilesActions.fetchCarImageSubmit ( { carId: action.carId, filename: filename } ),
                            ];
                            }),
                        catchError( errorResponse => [
                            FilesActions.imageFetchError( {errorMessage: "Error fetching image for car Id with filename =  "+action.file.name } )
                        ])
                        )
                    
            })
        )
    });
*/

    uploadCarImageFileData$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(FilesActions.uploadCarImageSubmit),
            mergeMap ( (action) => {
                return this.fileService
                    .uploadCarImageFileData(action.carId, action.file)
                    .pipe( 
                        mergeMap( (res) => { 
                            if(res.type === 4){
                                let car: Car = res.body;
                                return [
                                    FilesActions.uploadCarImageFileDataSuccess ( { car: car } ),
                                    FilesActions.fetchCarImageSubmit ( { carId: action.carId, filename: car.imagesFilenames[car.imagesFilenames.length -1]! } ),
                                ];
                            }
                            else{
                                return [
                                    //FilesActions.uploadCarImageFileAndFilenameSuccess ( { car: car } ),
                                    //FilesActions.fetchCarImageSubmit ( { carId: action.carId, filename: car.imagesFilenames.at(car.imagesFilenames.length -1)! } ),
                                ];
                            }
                                
                            }),
                        catchError( errorResponse => [
                            FilesActions.imageFetchError( {errorMessage: "Error fetching image for car Id with filename =  "+errorResponse } )
                        ])
                        )
                    
            })
        )
    });

    
    uploadCarDocumentFileData$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(FilesActions.uploadCarDocumentSubmit),
            mergeMap ( (action) => {
                return this.fileService
                    .uploadCarDocumentFileData(action.carId, action.file)
                    .pipe( 
                        mergeMap( (res) => { 
                            if(res.type === 4){
                                let car: Car = res.body;
                                return [
                                    FilesActions.uploadCarDocumentFileDataSuccess ( { car: car } ),
                                    FilesActions.fetchCarDocumentSubmit ( { carId: action.carId, filename: car.documentsFilenames[car.documentsFilenames.length -1]! } ),
                                ];
                            }
                            else{
                                return [
                                    //FilesActions.uploadCarImageFileAndFilenameSuccess ( { car: car } ),
                                    //FilesActions.fetchCarImageSubmit ( { carId: action.carId, filename: car.imagesFilenames.at(car.imagesFilenames.length -1)! } ),
                                ];
                            }
                                
                            }),
                        catchError( errorResponse => [
                            FilesActions.documentFetchError( {errorMessage: "Error fetching document for car Id with filename =  "+errorResponse } )
                        ])
                        )
                    
            })
        )
    });

    convertDocumentFileData$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(FilesActions.convertDocumentSubmit),
            mergeMap ( (action) => {
                return this.fileService
                    .convertDocument(action.carDocumentType, action.file)
                    .pipe( 
                        mergeMap( (res) => { 
                            if(res.type === 4){
                                let result: string = res.body;
                                return [
                                    FilesActions.convertDocumentSuccess ( { carDocumentType: action.carDocumentType, file: action.file, content: result } ),
                                ];
                            }
                            else{
                                return [
                                    //FilesActions.uploadCarImageFileAndFilenameSuccess ( { car: car } ),
                                    //FilesActions.fetchCarImageSubmit ( { carId: action.carId, filename: car.imagesFilenames.at(car.imagesFilenames.length -1)! } ),
                                ];
                            }
                                
                            }),
                        catchError( errorResponse => [
                            FilesActions.documentFetchError( {errorMessage: "Error converting document for car Id with filename =  "+errorResponse } )
                        ])
                        )
                    
            })
        )
    });


    fetchCarImages$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(FilesActions.fetchCarImageSubmit),
            //withLatestFrom(select(selectAllCarImagesFolders)),
            mergeMap ( (action) => {

                if (this.imageFolders.has(action.carId)){
                    
                    let i: number = 0;
                    let n = this.imageFolders.get(action.carId)?.length!;
        
                    while(i < n) {
                        //console.log('checking if filename = ' +action.filename+ ' is already there');
                        if( this.imageFolders.get(action.carId)?.at(i)!.filename === action.filename ){
                            //console.log('image with filename = ' +action.filename+ ' is already downloaded');
                            return []; 
                        }
                        i++;
                    }
                    //console.log(action.filename+ ' is to be downloaded - folder not empty');
                    
        
                }
                else { 
                    //console.log(action.filename+ ' is to be downloaded - folder empty');
                    
                }

                return this.fileService
                .getCarImageFile(action.filename)
                .pipe( 
                    mergeMap( (blob: Blob) => { 
                        //console.log("helhyloooo "+action.carId);
                        return [FilesActions.fetchCarImageSuccess ( {carId: action.carId, imageDatas: new FileData(action.filename, blob) } )];
                        }),
                    catchError( errorResponse => [
                        FilesActions.imageFetchError( {errorMessage: "Error fetching image for car Id =  "+action.carId } )
                    ])
                    ); 
            })
        )
    });


    
    fetchCarDocuments$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(FilesActions.fetchCarDocumentSubmit),
            //withLatestFrom(select(selectAllCarImagesFolders)),
            mergeMap ( (action) => {

                if (this.documentFolders.has(action.carId)){
                    
                    let i: number = 0;
                    let n = this.documentFolders.get(action.carId)?.length!;
        
                    while(i < n) {
                        //console.log('checking if filename = ' +action.filename+ ' is already there');
                        if( this.documentFolders.get(action.carId)?.at(i)!.filename === action.filename ){
                            //console.log('image with filename = ' +action.filename+ ' is already downloaded');
                            return []; 
                        }
                        i++;
                    }
                    //console.log(action.filename+ ' is to be downloaded - folder not empty');
                    
        
                }
                else { 
                    //console.log(action.filename+ ' is to be downloaded - folder empty');
                    
                }

                return this.fileService
                .getCarDocumentFile(action.filename)
                .pipe( 
                    mergeMap( (blob: Blob) => { 
                        //console.log("helhyloooo "+action.carId);
                        return [FilesActions.fetchCarDocumentSuccess ( {carId: action.carId, documentDatas: new FileData(action.filename, blob) } )];
                        }),
                    catchError( errorResponse => [
                        FilesActions.documentFetchError( {errorMessage: "Error fetching document for car Id =  "+action.carId } )
                    ])
                    ); 
            })
        )
    });


    fetchCarImageSample$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(FilesActions.fetchCarImageSampleSubmit),
            //withLatestFrom(select(selectAllCarImagesFolders)),
            mergeMap ( (action) => {

                if(this.imageSamples.has(action.filename)){
                    console.log('image already there = '+action.filename);
                    return [];
                }

                return this.fileService
                .getCarImageFile(action.filename)
                .pipe( 
                    mergeMap( (blob: Blob) => { 
                        console.log("helhyloooo "+action.filename);
                        return [FilesActions.fetchCarImageSampleSuccess ( {filename: action.filename, blob: blob } )];
                        }),
                    catchError( errorResponse => [
                        FilesActions.imageFetchError( {errorMessage: "Error fetching image sample for car Id =  "+action.filename } )
                    ])
                    ); 
            })
        )
    });

    // fetchCarImages2$ = createEffect( () => {
    //     return this.actions$.pipe(
    //         ofType(FilesActions.fetchCarImageSubmit),
    //         withLatestFrom(select(selectSearchFetchingResults)),
    //         mergeMap((rslt) => {
    //             //console.log(" 1 helhyloooo"+action.carId);
    //            rslt.pipe( (rs) => {
    //                 return rs;
    //            }))
                       
    //         }),
            
    //     );
    // });

   

      

/** 
    private getActionFromHttpEvent(event: HttpEvent<any>) {
        switch (event.type) {
            
          case HttpEventType.Sent: {
            return new fromFileUploadActions.UploadStartedAction();
          }
          case HttpEventType.UploadProgress: {
            return new fromFileUploadActions.UploadProgressAction({
              progress: Math.round((100 * event.loaded) / event.total)
            });
          }
          
          case HttpEventType.ResponseHeader:
          case HttpEventType.Response: {
            if (event.status === 200) {
              return new fromFileUploadActions.UploadCompletedAction();
            } else {
              return new fromFileUploadActions.UploadFailureAction({
                error: event.statusText
              });
            }
          }
          default: {
            return new fromFileUploadActions.UploadFailureAction({
              error: `Unknown Event: ${JSON.stringify(event)}`
            });
          }
        }
      }
*/ 
}
/**.*
 * mergeMap: DELETE - Subscribe immediately, never cancel or discard
 * concatmap: UPDATE or CREATE - Subscribe after last one finishes
 * exhaustMap: NON PARAMS GET -Discard until last one finishes
 * switchMap: PARAMS GET - Cancel the last one if it has not completed
 */